var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpinner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 18,
    stroke: "#18181F",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.0019 4.4083C29.5531 3.45351 29.2292 2.22252 28.2242 1.76914C24.4404 0.0621478 20.2017 -0.431946 16.0982 0.384295C11.3393 1.33091 7.08674 3.97529 4.13293 7.82477C1.17912 11.6743 -0.274525 16.4663 0.0428216 21.3081C0.316462 25.483 1.89078 29.4494 4.51892 32.6625C5.21695 33.5158 6.48985 33.5102 7.26943 32.7306C8.04902 31.951 8.03747 30.6936 7.3609 29.8231C5.40668 27.3087 4.23705 24.2548 4.02679 21.0469C3.7728 17.1717 4.93626 13.3363 7.30041 10.2553C9.66457 7.17424 13.0682 5.05774 16.8771 4.3001C20.03 3.67294 23.2827 4.01229 26.2172 5.24916C27.2331 5.67737 28.4506 5.3631 29.0019 4.4083Z",
    fill: "#00D1B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9981 35.5917C10.4469 36.5465 10.7708 37.7775 11.7758 38.2309C15.5596 39.9379 19.7983 40.4319 23.9018 39.6157C28.6607 38.6691 32.9133 36.0247 35.8671 32.1752C38.8209 28.3258 40.2745 23.5337 39.9572 18.6919C39.6835 14.517 38.1092 10.5506 35.4811 7.33755C34.7831 6.48417 33.5102 6.48985 32.7306 7.26944C31.951 8.04902 31.9625 9.30638 32.6391 10.1769C34.5933 12.6913 35.763 15.7452 35.9732 18.9531C36.2272 22.8283 35.0637 26.6637 32.6996 29.7447C30.3354 32.8258 26.9318 34.9423 23.1229 35.6999C19.97 36.3271 16.7173 35.9877 13.7828 34.7508C12.7669 34.3226 11.5494 34.6369 10.9981 35.5917Z",
    fill: "#00D1B2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.a5445d3acbe6e59d3b4be79fcc5ec115.svg";
export { ForwardRef as ReactComponent };